export function camelToTitleCase(str: string) {
  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase to camel Case
    .replace(/([a-zA-Z])(\d+)/g, "$1 $2") // add space before numbers
    .replace(/^./, (s) => s.toUpperCase())
    .replace("-", " ")
    .trim();
}

// more generic version of camelToTitleCase
export function titleCase(str: string) {
  return str
    .split(/[-_]/)
    .map((s) => camelToTitleCase(s))
    .join(" ");
}

export function sentenceCase(str: string) {
  const words = str.split(/[-_]/).join(" ");
  return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
}

export function lowercaseFirstLetter(str: string) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}
